// extracted by mini-css-extract-plugin
export default {"galleryButton":"qj3QU","icon":"qktS0","text":"LE9Nz"};